/**
 * Scrolls to a DOM element using the provided CSS selector
 * and applies the specified offset (in pixels)
 * @param selector
 * @param offset
 */
export function scrollToElement(elementSelector, scrollContainerSelector, offset = 100) {
  // selecting the element to scroll into;
  const element = document.querySelector(elementSelector);
  // selecting the main element to be scroll, ex. pro profile page
  const win = document.querySelector(scrollContainerSelector);

  if (!element) return;
  if (element.offsetParent !== null) {
    // Element is visible (note: doesn't work with position: fixed elems)
    // where on the screen the element' top is
    const targetPosition = element.getBoundingClientRect().top + win.scrollTop;

    win.scrollTo({
      y: targetPosition - offset,
      behavior: 'smooth',
    });
  }
}
